import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './auth-guard.service';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'forms',
    canActivate: [AuthGuardService],
    //   // data: { preload: true },
    loadChildren: () => import('./cms-forms/cms-forms.module').then(m => m.CmsFormsModule)
  },
  {
    path: 'masterdata',
    canActivate: [AuthGuardService],
    //   // data: { preload: true },
    loadChildren: () => import('./masterdata/masterdata.module').then(m => m.MasterdataModule)
  },
  {
    path: 'settings',
    canActivate: [AuthGuardService],
    //   // data: { preload: true },
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'templates',
    canActivate: [AuthGuardService],
    //   // data: { preload: true },
    loadChildren: () => import('./templates/templates.module').then(m => m.TemplatesModule)
  },
  {
    path: 'users',
    canActivate: [AuthGuardService],
    //   // data: { preload: true },
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
  },
  {
    path: '', component: HomeComponent, canActivate: [AuthGuardService]
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes /*, { enableTracing: true }*/, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
